module.exports = __webpack_public_path__ + "media/images/emblems/Stemma_Terre_di_Pedemonte-157140684b87c5b20d58aba0cb28bbf8.png";